const GET_CURRENT_USER_INFORMATION: string = 'GET_CURRENT_USER_INFORMATION';
const VALIDATE_CURRENT_USER_INFORMATION: string = 'VALIDATE_CURRENT_USER_INFORMATION';
const GET_CURRENT_USER_VIEWREF: string = 'GET_CURRENT_USER_VIEWREF';
const VALIDATE_IDENTITY_QUESTIONS: string = 'VALIDATE_IDENTITY_QUESTIONS';
const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
const VALIDATE_FARS = 'VALIDATE_FARS';

export const RIDP_ACTION_TYPES = {
    GET_CURRENT_USER_INFORMATION,
    VALIDATE_CURRENT_USER_INFORMATION,
    GET_CURRENT_USER_VIEWREF,
    VALIDATE_IDENTITY_QUESTIONS,
    SET_ERROR_MESSAGE,
    UPLOAD_DOCUMENT,
    VALIDATE_FARS,
};
